<template>
  <div id="app">

    <v-app toolbar slot="activator">

    <v-navigation-drawer absolute persistent light v-model="drawer" overflow class="blue-grey darken-2" style="position: fixed">
      <v-toolbar flat class="transparent" id="sidebar-menu">
        <v-list class="pa-0 transparent">
          <v-list-tile avatar class="mt-4">
            <v-list-tile-avatar>
              <img v-if="!user" src="./assets/placeholder-user.png" />
              <img v-if="user" :src="user.photoURL" />
            </v-list-tile-avatar>
            <v-list-tile-content class="grey--text text--lighten-2">
              <v-list-tile-title v-if="user">{{user.displayName}}</v-list-tile-title>
              <v-list-tile-title v-if="!user">Bitte anmelden</v-list-tile-title>
              <v-list-tile-sub-title v-if="myHcp" class="grey--text text--lighten-2">Handycap {{myHcp}}</v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="!myHcp && user" class="grey--text text--lighten-2">Bitte Handycap eingeben</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-btn class="right mt-3 mr-3 warning" v-if="!user" @click="login">Anmelden</v-btn>
          <v-btn class="right mt-3 mr-3 warning" v-if="user" @click="logout">Abmelden</v-btn>
        </v-list>
      </v-toolbar>
      <div v-if="user">
      <v-list class="pt-0 transparent" v-if="myHcp">
        <v-divider></v-divider>
        <v-list-tile @click="getActualRound" :to="'/'">
          <v-list-tile-action>
            <v-icon class="grey--text text--lighten-2">mode_edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="grey--text text--lighten-2">
            <v-list-tile-title>Aktuelle Runde</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="getLastRounds" :to="'/LetzteRunden'" >
          <v-list-tile-action>
            <v-icon class="grey--text text--lighten-2">replay_5</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="grey--text text--lighten-2">
            <v-list-tile-title>Letzte 5 Runden</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="x" :to="'/SucheRunde'">
          <v-list-tile-action>
            <v-icon class="grey--text text--lighten-2">search</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="grey--text text--lighten-2">
            <v-list-tile-title>Suche Runde</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider class="grey lighten-1"></v-divider>
      <v-list class="pt-0 transparent">
        <v-list-tile @click.stop="openDialog">
          <v-list-tile-action>
            <v-icon class="grey--text text--lighten-2">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="grey--text text--lighten-2">
            <v-list-tile-title>Handycap eingeben</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider class="grey lighten-1"></v-divider>
      <v-list class="pt-0 transparent" v-if="myHcp">
        <v-list-tile @click="newRoundYellow" :to="'/'">
          <v-list-tile-action>
            <v-icon class="yellow--text">golf_course</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="yellow--text">
            <v-list-tile-title>Neue Runde</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="x" :to="'/'">
          <v-list-tile-action>
            <v-icon class="white--text">golf_course</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="white--text">
            <v-list-tile-title>Neue Runde</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      </div>
    </v-navigation-drawer>

    <v-toolbar fixed class="blue-grey darken-2" dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>MyGolfApp</v-toolbar-title>
    </v-toolbar>

    <main>
      <v-container fluid id="main">
        <!--v-router-->
        <router-view></router-view>
      </v-container>
    </main>
  </v-app>
    
  <v-dialog v-model="dialog" lazy absolute>
    <v-card>
      <v-card-title>
        <div class="headline">Handycap eingeben</div>
      </v-card-title>
      <v-card-text>
        <p>Bitte geben Sie Ihr Handycap ein,<br>z.B. -12,4</p>
        <p v-if="myHcp != null"><strong>Aktuelles Handycap {{myHcp}}</strong></p>
      <v-form>
        <v-text-field
          label="Handycap"
          v-model="number"
          type="number"
        ></v-text-field>
      </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="red--text darken-1" flat="flat" @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn class="blue--text darken-1" flat="flat" @click.native="setHcp">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    
  </div>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {
      drawer: true,
      dialog: false,
      number: null
    }
  // End Data
  },

  // watch: {
  
  // },

  computed: {
    user(){
      return this.$store.getters.user
    },
    myHcp(){
      return this.$store.getters.myHcp
    },
    lastFiveRounds(){
      return this.$store.getters.lastFiveRounds
    }
  // End Computed
  },

  methods: {
    
    x() {
      
    },

    login() {
      this.$store.dispatch('login');
    },
    logout() {
      this.$store.dispatch('logout');
    },
    getActualRound() {
      this.$store.dispatch('loadActualRoundKey')
      var size = window.innerWidth
      if (size < 960) {
        this.drawer = false
      }
    },
    getLastRounds() {
      this.$store.dispatch('getLastRounds')
      var size = window.innerWidth
      if (size < 960) {
        this.drawer = false
      }
    },
    openDialog(){
      this.dialog = true
      var size = window.innerWidth
      if (size < 960) {
        this.drawer = false
      }
    },
    setHcp() {
      this.$store.dispatch('setHcp', this.number);
      this.number = null;
      this.dialog = false;
    },
    newRoundYellow() {
      this.$store.dispatch('newRoundYellow')
      this.$store.dispatch('loadActualRoundKey')
      var size = window.innerWidth
      if (size < 960) {
        this.drawer = false
      }
    }
  // End Methods
  }
}
</script>

<style>

  #sidebar-menu {
    background-image: url(./assets/dark-background.png);
    min-height: 150px;
  }

  @media (max-width: 667px) {
    #main {
      padding: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?7199a157